import { ProductDocument, Variation } from 'models/product';
import Link from 'next/link';

type ProductSpecsProps = {
  product: ProductDocument;
  selectedVariations: Variation[] | null;
};

export default function ProductSpecs({
  product,
  selectedVariations,
}: ProductSpecsProps) {
  const hasSizeVariations = product.variations?.some(
    (v) => v.size && v.size !== 'N/A'
  );
  const hasColorVariations = product.variations?.some((v) => v.color);

  const specs = selectedVariations
    ? selectedVariations[0].specs ?? product.specs
    : product.specs;
  return (
    <>
      {specs && Object.keys(specs).length > 0 && (
        <div className="flex flex-col gap-y-2">
          <p className="mb-[1rem] text-[1.8rem] font-semibold">Specs:</p>
          {product.has_variations && !selectedVariations?.length && (
            <Link
              href={`#`}
              className="mb-[1rem] text-[1.6rem] font-semibold underline"
            >
              Select a variation to see more accurate specs.
            </Link>
          )}
          <table className="w-full text-left">
            <tbody className="flex flex-col gap-y-2">
              {selectedVariations?.length && (
                <tr>
                  <td className="w-[14rem] py-1 pr-2 text-[1.6rem]">MPN:</td>
                  <td className="grow py-1 pr-2 text-[1.6rem] font-semibold text-brand-black">
                    {selectedVariations[0].mpn?.[0]}
                  </td>
                </tr>
              )}
              {Object.entries(specs)
                .sort()
                .filter(([key]) => {
                  if (
                    hasSizeVariations &&
                    key.toLowerCase() === 'size' &&
                    !selectedVariations?.length
                  )
                    return false;
                  if (
                    hasColorVariations &&
                    key.toLowerCase() === 'color' &&
                    !selectedVariations?.length
                  )
                    return false;
                  return true;
                })
                .map(([key, value]) => (
                  <tr className="flex flex-row" key={key}>
                    <td className="w-[14rem] py-1 pr-2 text-[1.6rem]">
                      {key}:
                    </td>
                    <td className="grow py-1 pr-2 text-[1.6rem] font-semibold text-brand-black">
                      {typeof value === 'number'
                        ? value.toLocaleString()
                        : value}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
